import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=7cda651b&scoped=true&lang=pug"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=7cda651b&prod&lang=scss&scoped=true"
import style1 from "./Main.vue?vue&type=style&index=1&id=7cda651b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cda651b",
  null
  
)

export default component.exports